import rightDoorClassic from 'assets/warehouse/classic/rightDoor.png'
import leftDoorClassic from 'assets/warehouse/classic/leftDoor.png'
import interiorClassic from 'assets/warehouse/classic/interior.png'
import interiorIgotech from 'assets/warehouse/igotech/interior.png'
import rightDoorHT from 'assets/warehouse/htbox/rightDoor.png'
import leftDoorHT from 'assets/warehouse/htbox/leftDoor.png'
import interiorHT from 'assets/warehouse/htbox/interior.png'
import rightDoorMM from 'assets/warehouse/mm/rightDoor.png'
import leftDoorMM from 'assets/warehouse/mm/leftDoor.png'
import interiorMM from 'assets/warehouse/mm/interior.png'
import { useEffect } from 'react'

const PRELOADED_IMAGES = process.env.REACT_APP_TYPE === 'mm'
  ? [interiorMM, leftDoorMM, rightDoorMM]
  : (process.env.REACT_APP_TYPE === 'rze01' || process.env.REACT_APP_TYPE === 'demo' || process.env.REACT_APP_TYPE === 'krk01')
    ? [interiorHT, leftDoorHT, rightDoorHT]
    : process.env.REACT_APP_TYPE === 'chr01'
    ? [interiorIgotech]
    : [interiorClassic, leftDoorClassic, rightDoorClassic]

const idleCallback = window.requestIdleCallback || ((fn) => setTimeout(fn, 1))
const cancelIdle = window.cancelIdleCallback || clearTimeout

const useWarehouseImagesPreload = () => {
  useEffect(() => {
    const id = idleCallback(() => {
      PRELOADED_IMAGES.forEach(src => {
        const img = new Image()
        img.src = src
      })
    })
    return () => {
      cancelIdle(id)
    }
  }, [])
}

export default useWarehouseImagesPreload